"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M8.99242 9.366V8.619H3.84442V9.366H6.01342V15H6.83242V9.366H8.99242ZM14.6455 15L12.4225 11.139L14.6365 8.619H13.6465L10.7755 11.895V8.619H9.96547V15H10.7755V13.02L11.8555 11.787L13.7005 15H14.6455ZM19.5515 15V14.28H16.7435L18.9215 11.643C19.2635 11.22 19.4525 10.806 19.4525 10.311C19.4525 9.915 19.3535 9.609 19.1645 9.339C18.8495 8.898 18.2915 8.619 17.6075 8.619C16.5005 8.619 15.7355 9.357 15.7355 10.446H16.5275C16.5275 9.618 17.0585 9.312 17.6165 9.312C18.2735 9.312 18.6695 9.681 18.6695 10.32C18.6695 10.644 18.5705 10.932 18.3275 11.22L15.7445 14.343V15H19.5515Z",
    fill: "black"
  }), _react.default.createElement("path", {
    d: "M1 1H23V-1H1V1ZM23 1V23H25V1H23ZM23 23H1V25H23V23ZM1 23V1H-1V23H1ZM1 23L1 23H-1C-1 24.1046 -0.104568 25 1 25V23ZM23 23L23 23V25C24.1046 25 25 24.1046 25 23H23ZM23 1L23 1H25C25 -0.10457 24.1046 -1 23 -1V1ZM1 -1C-0.10457 -1 -1 -0.104568 -1 1H1L1 1V-1Z",
    fill: "#999999"
  }));
};

exports.default = _default;
module.exports = exports.default;